module.exports = __webpack_public_path__ + "static/media/supportActive.cebcbf5a.svg";